module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appName')
    }
  }, [_c('el-input', {
    staticClass: "aeMg contentColor",
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.appName),
      callback: function($$v) {
        _vm.appName = $$v
      },
      expression: "appName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_udState')
    }
  }, [_c('el-input', {
    staticClass: "aeMg contentColor",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 1000
      }
    },
    model: {
      value: (_vm.appDesc),
      callback: function($$v) {
        _vm.appDesc = $$v
      },
      expression: "appDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_selectApp')
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "drag": "",
      "accept": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl
    }
  }, [_c('span', [(_vm.ulinfo.index == 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index == 1),
      expression: "ulinfo.index == 1"
    }],
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    staticStyle: {
      "color": "#13CE66"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index == 2),
      expression: "ulinfo.index == 2"
    }],
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    staticStyle: {
      "color": "#FF4949"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-5px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：" + _vm._s(_vm.version))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：" + _vm._s(_vm.verTag))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：" + _vm._s(_vm.spackage))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')) + "apk/hap")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index == 0),
      expression: "ulinfo.index == 0"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "calc(100% + 20px)",
      "background": "#EAEEFA",
      "height": "1px",
      "margin-left": "-10px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "appTypeValue"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_type'),
      "prop": "appTypeValue"
    }
  }, [_c('el-cascader', {
    attrs: {
      "expand-trigger": "hover",
      "options": _vm.appTypes,
      "show-all-levels": false
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.appTypeValue),
      callback: function($$v) {
        _vm.appTypeValue = $$v
      },
      expression: "appTypeValue"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_introl'),
      "prop": "appDesc1"
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "autosize": {
        minRows: 2,
        maxRows: 10
      },
      "type": "textarea"
    },
    model: {
      value: (_vm.appDesc1),
      callback: function($$v) {
        _vm.appDesc1 = $$v
      },
      expression: "appDesc1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSm),
      expression: "loadingSm"
    }],
    attrs: {
      "label": _vm.$t('app_icon')
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader aeMg",
    attrs: {
      "accept": "image/*",
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "on-success": _vm.handleSmAvatarSuccess,
      "before-upload": _vm.beforeSmAvatarUpload
    }
  }, [(_vm.smImageUrl) ? _c('img', {
    staticClass: "sm-avatar",
    attrs: {
      "src": _vm.smImageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus sm-avatar-uploader-icon"
  })]), _vm._v("\n\t\t\t\t\t  "), _c('label', {
    staticClass: "contentColor"
  }, [_vm._v(_vm._s(_vm.$t('app_iconState')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingBig),
      expression: "loadingBig"
    }],
    attrs: {
      "label": _vm.$t('app_larIcon')
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader aeMg",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "on-success": _vm.handleBgAvatarSuccess,
      "before-upload": _vm.beforeBgAvatarUpload
    }
  }, [(_vm.bgImageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.bgImageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v("\n\t\t\t\t\t  "), _c('label', {
    staticClass: "contentColor"
  }, [_vm._v(_vm._s(_vm.$t('app_larIconState')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading1),
      expression: "loading1"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_screenShot')
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "15px"
    }
  }, [_c('el-upload', {
    staticClass: "capture",
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp0
    }
  }, [(_vm.cp0) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp0
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture0()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp1
    }
  }, [(_vm.cp1) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp1
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture1()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp2
    }
  }, [(_vm.cp2) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp2
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture2()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp3
    }
  }, [(_vm.cp3) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp3
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture3()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "accept": "image/*",
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp4
    }
  }, [(_vm.cp4) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp4
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture4()
      }
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadApp
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _c('br')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ca7f68a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/appNewVersion.vue
// module id = 1002
// module chunks = 0